package com.nonopn.skywatcher.management.app.home

import androidx.compose.runtime.Composable
import com.nonopn.skywatcher.app.utils.AppBackPressProvider
import com.nonopn.skywatcher.common.app.home.AppCommon
import com.nonopn.skywatcher.common.app.home.AppModelManager

@Composable
fun App(
    isDarkTheme: Boolean,
    onBackPressed: AppBackPressProvider = AppBackPressProvider()
) {
    AppCommon(
        isDarkTheme = isDarkTheme,
        onBackPressed = onBackPressed
    ) { isSystemDarkTheme -> AppModelManager(isSystemDarkTheme) }
}
